export default __webpack_public_path__ + "css/productCategoryPrice.bundle.css";